import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M10.01 22.137s-2.38-.99-1.015-4.99c1.716-4.99 6.667-2.335 3.598-.61-1.841.61-1.53-2.435-2.623-5.37-1.092-2.935-1.637-4.586 1.053-5.1s4.055 6.751 4.055 6.751 3.042.294 4.134 1.395.702 7.117.702 7.117"
    />
    <path
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M4.213 11.498S.9 7.02 5.227 4.453M6.89 9.736c-.858-1.724-.624-2.898.35-3.779M13.675 4.637c1.832.807 2.261 1.797 2.105 3.045M15.475 2.45s5.025.8 3.549 6.365"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
  </svg>
);
export const TouchIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
